import HamiltonModule from '@/models/HamiltonModule'
import ImpressionConcolidationWidget from './ImpressionConcolidationWidget'

export default class RevenueConcolidationWidget extends ImpressionConcolidationWidget {
  constructor(args: any = null) {
    super({
      title: 'Revenue Delivered',
      key: 'revenue-consolidation',
      metrics: ['revenue'],
      format_totals: '$0.00a',
      ...(args || {}),
    })
  }

  public dataSource() {
    if (this.dataSourceRequest) {
      return this.dataSourceRequest(this.payload)
    }

    const request = new HamiltonModule()

    return request
      .revenueConsolidation({ module: this.payload, ignore_logic: true })
      .then((res: any) => res.result)
  }
}
